export enum SocketMessageType {
  GET_RESPONSE = "get_response",
  NEW_RESPONSE = "new_response",
  RESPONSE_COMPLETE = "response_complete",
  REFRESH_CHAT = "refresh_chat",
  CONNECT = "connect",
  DISCONNECT = "disconnect",
  EVENTS_FROM_BACKEND = "events_from_backend",
  ERROR = "error",
  RECONNECT_FAILED = "reconnect_failed",
  CHAT_CLOUD_RESPONSE_COMPLETE = "chat_cloud_response_complete",
  OPERATOR = "operator",
  LIVE_AGENT_DISCONNECTED = "live_agent_disconnected",
  LIVE_AGENT_CONNECTED = "live_agent_connected",
  LIVE_AGENT_RESPONSE = "live_agent_response",
  OFFER_CALENDAR = "offer_calendar",
  CALL_ACCEPTED = "call_accepted",
  CALL_REJECTED = "call_rejected",
  CHAT_ENDED = "chat_ended",
  LIVE_AGENT_BROWSING_MESSAGE = "live_agent_browsing_message",
  NOTIFY_USER_OF_AGENT_TYPING = "notify_user_of_agent_typing",
  MARK_ALL_MESSAGES_AS_READ = "mark_all_messages_as_read",
}
